import { FC, useRef } from "react";
import styles from "./main.module.scss";
import { motion, useInView } from "framer-motion";

interface ComponentProps {
  whys: WhyUs[];
}

const WhySchool: FC<ComponentProps> = ({ whys }) => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-100px" });

  return (
    <motion.section
      className={styles.whySchool}
      ref={sectionRef}
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {/* <div className={styles.heading}>
        <h2>Why James Hope University?</h2>
        <span className="underline"></span>
      </div> */}

      <div className={styles.smallGap}>
        {whys &&
          whys?.length > 0 &&
          whys?.map((item, i) => (
            <motion.div
              className={styles.why}
              key={item.id}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, ease: "easeOut", delay: i * 0.2 }}
            >
              <img src={item.iconUrl} alt="icon" className={styles.whyIcon} />
              <h3>{item.name}</h3>
              <p>{item.description}</p>
            </motion.div>
          ))}
      </div>
    </motion.section>
  );
};

export default WhySchool;
